import firebaseApp from '../../firebase/firebase';
import {
  SIGNUP_USER,
  CHECK_CHANGED,
  EMAIL_CHANGED,
  PASSWORD_CHANGED,
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAIL,
  LOGOUT_USER_SUCCESS,
  LOGOUT_USER_FAIL,
  USER_AUTHED,
  USER_NOT_AUTHED
} from '../../_actions/types';

export const loginUser = ({ email, password, checked}) => {
  return (dispatch) => {
    dispatch({ type: LOGIN_USER });
    firebaseApp.auth().signInWithEmailAndPassword(email, password)
    .then(user => loginUserSuccess(dispatch,user,checked))
    .catch(() => loginUserFail(dispatch))
  };
}

export const signUpUser = ({ email, password, checked }) => {
  return (dispatch) => {
    dispatch({ type: SIGNUP_USER });
    firebaseApp.auth().createUserWithEmailAndPassword(email,password)
    .then(user => loginUserSuccess(dispatch, user, checked))
    .catch(() => loginUserFail(dispatch));
  }
}

const loginUserFail = (dispatch) => {
  dispatch({ type: LOGIN_USER_FAIL })
}

const loginUserSuccess = (dispatch, user, checked) => {
    const updates = {}
    updates[`users/${user.uid}/meta/email`] = user.email
    updates[`users/${user.uid}/meta/name`] = user.displayName? user.displayName : user.email
    updates[`users/${user.uid}/meta/photo`] = user.photoURL? user.photoURL : ''
    updates[`users/${user.uid}/meta/id`] = user.uid
    updates[`users/${user.uid}/meta/realtor`] = checked
    firebaseApp.database().ref().update(updates).then(() => {
      dispatch({ type: LOGIN_USER_SUCCESS, payload:user })
    })
}

export const emailChanged = (text) => {
  return { type: EMAIL_CHANGED, payload: text };
};

export const passwordChanged = (text) => {
  return { type: PASSWORD_CHANGED, payload: text };
};

export const checkChanged = (value) => {
  return {type: CHECK_CHANGED, payload: value}
}

export const checkAuth = () => {
  return dispatch => {
    firebaseApp.auth().onAuthStateChanged((user) => {
      if (user) {
        firebaseApp.database().ref(`users/${user.uid}`).on('value', snapshot => {
          userAuthed(dispatch, user, snapshot.val().meta.realtor)
        })
      } else {
        userNotAuthed(dispatch, user)
      }
    })
  }
}

const userAuthed = (dispatch, user, realtor) => {
  dispatch({ type: USER_AUTHED, user: user, realtor: realtor })
}

const userNotAuthed = (dispatch, user) => {
  dispatch({ type: USER_NOT_AUTHED })
}

export const logoutUser = () => {
  return (dispatch, getState) => {
    firebaseApp.auth().signOut()
    .then(() => logoutUserSuccess(dispatch, getState)).catch(() => logoutUserFail(dispatch))
  }
}

const logoutUserSuccess = (dispatch, getState) => {
  dispatch({ type: LOGOUT_USER_SUCCESS })
}


const logoutUserFail = (dispatch) => {
  dispatch({ type: LOGOUT_USER_FAIL })
}



// WEBPACK FOOTER //
// ./src/components/auth/auth_actions.js